import jwtDecode from 'jwt-decode'

export default class UserService {

    constructor () {
        this.key = 'token'
    }

    setToken (token) {
        window.localStorage.setItem(this.key, token)
    }

    getToken () {
        const token = window.localStorage.getItem(this.key)
        return token ? token : ''
    }

    isLoggedIn () {
        const token = this.getToken()

        return token.length > 0
    }

    getUser () {
        const token = this.getToken()

        return jwtDecode(token).sub
    }

    removeToken () {
        return window.localStorage.removeItem(this.key)
    }
}

export function currentUser () {
    const service = new UserService

    return service.getUser()
}

export function isLoggedIn () {
    const service = new UserService

    return service.isLoggedIn()
}

export function getToken () {
    const service = new UserService

    return service.getToken()
}

export function removeToken () {
    const service = new UserService

    return service.removeToken()
}
